import React from 'react';
import clsx from 'clsx';
import {composeClasses, styled, WithClasses} from '../Theme';
import {
	getSentinelUtilityClass,
	ScrollSentinelClasses,
} from './scrollSentinelClasses';

type ScrollSentinelUtilityClasses = WithClasses<ScrollSentinelClasses, {}>;

const useUtilityClasses = (ownerState: ScrollSentinelUtilityClasses) => {
	const {classes} = ownerState;
	const slots = {
		root: ['root'],
	};
	return composeClasses(slots, getSentinelUtilityClass, classes);
};

const ScrollSentinelRoot = styled('div', {
	name: 'ScrollSentinel',
	slot: 'Root',
})(({theme}) => ({
	flex: '0 0 auto',
	height: 1,
	width: 1,
}));

export interface ScrollSentinelProps
	extends React.DetailedHTMLProps<
			React.HTMLAttributes<HTMLDivElement>,
			HTMLDivElement
		>,
		WithClasses<ScrollSentinelClasses, {}> {}

export const ScrollSentinel = React.forwardRef<
	HTMLDivElement,
	ScrollSentinelProps
>(({classes: _classes, className, ...props}, ref) => {
	const classes = useUtilityClasses({classes: _classes});
	return (
		<ScrollSentinelRoot
			className={clsx(classes.root, className)}
			ref={ref}
			{...props}
		/>
	);
});

export default ScrollSentinel;
